import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const walletTopupApi = createApi({
  reducerPath: "walletTopup",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  tagTypes: ["WalletTopup", "OkkaliraRate"],
  keepUnusedDataFor: 120,
  endpoints(builder) {
    return {
      getWalletTopups: builder.query({
        query: ({ token, page, limit, status }) => ({
          url: `/api/walletTopups/storageRoles`,
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
          params: { page, limit, ...(status && { status }) },
        }),
        providesTags: ["WalletTopup"],
      }),
      // Birleşik işlemler: yükleme + satış + iade
      getWalletTransactions: builder.query({
        // search / startDate / endDate / counts (#242) —
        // Sözleşme: Workspace docs/api-contracts/wallet-transactions-panel.md
        query: ({ token, page, limit, type, status, search, startDate, endDate }) => ({
          url: `/api/walletTopups/storageRoles/transactions`,
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
          params: {
            page,
            limit,
            ...(type && { type }),
            ...(status && { status }),
            ...(search && { search }),
            ...(startDate && { startDate }),
            ...(endDate && { endDate }),
          },
        }),
        providesTags: ["WalletTopup"],
      }),
      // Okkalira kuru — 1 Okkalira = X kuruş (#400)
      // Sözleşme: Workspace docs/api-contracts/okkalira-spend.md §1
      getOkkaliraRate: builder.query({
        query: ({ token }) => ({
          url: `/api/walletTopups/storageRoles/okkaliraRate`,
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }),
        providesTags: ["OkkaliraRate"],
      }),
      updateOkkaliraRate: builder.mutation({
        query: ({ token, rateKurus }) => ({
          url: `/api/walletTopups/storageRoles/okkaliraRate`,
          method: "PATCH",
          headers: { Authorization: `Bearer ${token}` },
          body: { rateKurus },
        }),
        invalidatesTags: ["OkkaliraRate"],
      }),
    };
  },
});

export const {
  useGetWalletTopupsQuery,
  useLazyGetWalletTopupsQuery,
  useGetWalletTransactionsQuery,
  useLazyGetWalletTransactionsQuery,
  useGetOkkaliraRateQuery,
  useUpdateOkkaliraRateMutation,
} = walletTopupApi;
export { walletTopupApi };
